export enum PaymentMethodPurchaseOrder {
    Boleto = 1,
    Transferencia = 2,
    CartaoCredito = 3
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/PaymentMethodPurchaseOrder.ts